import React from 'react';
// eslint-disable-next-line camelcase
import jwt_decoded from 'jwt-decode';

import { LocalStorageProvider as LSP } from 'providers';

const initial = {
    // Authentication variables
    auth: LSP.get('100os-auth') || {},
    user: LSP.get('100os-user') || {},
    tokn: false,
    authenticated: false,
};

// Tries to set the state to auhenticated
// If everything is ok with the userid and token
if (initial.auth.token && initial.user.userid) {
    try {
        initial.tokn = jwt_decoded(initial.auth.token);
        initial.authenticated = true;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('ContextAuth', 'Initial Token is not valid');
        initial.authenticated = false;
    }
}

const contextReducer = (state, action) => {
    const reduce = {
        AUTHENTICATE: () => {
            try {
                const { auth } = action;
                // Tries to decode the JWT token
                const tokn = jwt_decoded(auth.token);
                // Create fullname variable
                const user = { ...action.user, fullname: '' };
                if (user.firstName && user.lastName) {
                    user.fullname = `${user.firstName} ${user.lastName}`;
                }
                // Write values to the localStorage
                LSP.set('100os-auth', auth);
                LSP.set('100os-user', user);
                return { auth, user, tokn, authenticated: true };
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('ContextAuth', 'Token is not valid');
                return { ...initial };
            }
        },
        UNAUTHENTICATE: () => {
            LSP.set('100os-auth', action.auth || {});
            LSP.set('100os-user', action.user || {});
            return { ...state, auth: {}, user: {}, tokn: {}, authenticated: false };
        },
        // Update only the authentication info
        UPDATE_AUTH_INFO: () => {
            LSP.set('100os-auth', action.auth || {});
            return { ...state, auth: action.auth };
        },
        // Update only the authenticated user
        UPDATE_USER_INFO: () => {
            // Create fullname variable
            const user = { ...action.user };
            if (user.firstName && user.lastName) {
                user.fullName = `${user.firstName} ${user.lastName}`;
            }
            LSP.set('100os-user', user || {});
            return { ...state, user };
        },
        // Update only the authenticated user's avatar
        UPDATE_USER_AVATAR: () => {
            const user = { ...state.user, photoUrl: action.photoUrl };
            LSP.set('100os-user', user || {});
            return { ...state, user };
        },
    }[action.type];
    return (reduce && reduce()) || state;
};

// Create the proper context variables
export const ContextAuth = React.createContext();
export const ContextAuthProvider = ({ children }) => {
    const [state, dispatch] = React.useReducer(contextReducer, initial);
    const stateValue = { state, dispatch, authState: state, authDispatch: dispatch };
    return <ContextAuth.Provider value={stateValue}>{children}</ContextAuth.Provider>;
};

// Create some shortcuts to export
export const CA = ContextAuth;
export const CAP = ContextAuthProvider;
